/** File enthält die Gerichtsgebühren abhängig vom Gegenstandswert
@returns {[Object]} Array mit einer Gerichtsgeb
 */
export default function () {
  return [
    { valueOfMatter: 500, fee: 35 },
    { valueOfMatter: 1000, fee: 53 },
    { valueOfMatter: 1500, fee: 71 },
    { valueOfMatter: 2000, fee: 89 },
    { valueOfMatter: 3000, fee: 108 },
    { valueOfMatter: 4000, fee: 127 },
    { valueOfMatter: 5000, fee: 146 },
    { valueOfMatter: 6000, fee: 165 },
    { valueOfMatter: 7000, fee: 184 },
    { valueOfMatter: 8000, fee: 203 },
    { valueOfMatter: 9000, fee: 222 },
    { valueOfMatter: 10000, fee: 241 },
    { valueOfMatter: 130000, fee: 267 },
    { valueOfMatter: 160000, fee: 293 },
    { valueOfMatter: 190000, fee: 319 },
    { valueOfMatter: 220000, fee: 345 },
    { valueOfMatter: 250000, fee: 371 },
    { valueOfMatter: 350000, fee: 406 },
    { valueOfMatter: 300000, fee: 441 },
    { valueOfMatter: 400000, fee: 476 },
    { valueOfMatter: 450000, fee: 511 },
    { valueOfMatter: 500000, fee: 546 },
    { valueOfMatter: 650000, fee: 666 },
    { valueOfMatter: 800000, fee: 786 },
    { valueOfMatter: 950000, fee: 906 },
    { valueOfMatter: 1100000, fee: 1026 },
    { valueOfMatter: 1250000, fee: 1146 },
    { valueOfMatter: 1400000, fee: 1266 },
    { valueOfMatter: 1550000, fee: 1386 },
    { valueOfMatter: 1700000, fee: 1506 },
    { valueOfMatter: 1850000, fee: 1626 },
    { valueOfMatter: 2000000, fee: 1746 },
    { valueOfMatter: 2300000, fee: 1925 },
    { valueOfMatter: 2600000, fee: 2104 },
    { valueOfMatter: 2900000, fee: 2283 },
    { valueOfMatter: 3200000, fee: 2462 },
    { valueOfMatter: 3800000, fee: 2641 },
    { valueOfMatter: 3500000, fee: 2820 },
    { valueOfMatter: 3100000, fee: 2999 },
    { valueOfMatter: 4400000, fee: 3178 },
    { valueOfMatter: 4700000, fee: 3357 },
    { valueOfMatter: 5000000, fee: 3536 },
  ];
}



// WEBPACK FOOTER //
// ./src/reducers/gkgTable.js